// extracted by mini-css-extract-plugin
export var headerText = "header-module--headerText--sAF8i";
export var headerTitle = "header-module--headerTitle--qjsMK";
export var lineIcon = "header-module--lineIcon--2hKp9";
export var bcgColor = "header-module--bcgColor--VuN3B";
export var headerBCG = "header-module--headerBCG--gbAhV";